<template>
  <div>
    <div v-if="hasAuth">
      <!-- 기본 도구 -->
      <el-row :gutter="4" class="mr-b4">
        <el-col :span="12">
          <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
        </el-col>
        <el-col :span="12">
          <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
        </el-col>
      </el-row>
      <el-row :gutter="4" class="mr-b25">
        <el-col :span="12">
          <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
        </el-col>
        <el-col :span="12">
          <w-common-script-popup-button v-if="isStandalone" :obj-info="objInfo"></w-common-script-popup-button>
        </el-col>
      </el-row>
      <!-- 관리 도구 -->
      <div v-if="isStandalone">
        <div class="title-h4 title-bar">WatchAll 관리 도구</div>
        <el-row :gutter="4" style="margin-bottom:4px;">
          <el-col :span="12">
            <w-device-modeling-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
          </el-col>
          <el-col :span="12">
            <w-daily-check-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
          </el-col>
        </el-row>
        <el-row :gutter="4" class="mr-b25">
          <el-col :span="12">
            <w-config-backup-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
          </el-col>
          <el-col :span="12">
            <w-netdevice-user-define-oid-rsc-popup-button :obj-info="objInfo" />
          </el-col>
        </el-row>
      </div>
      <!-- 무선 AP 원격 제어 -->
      <div v-if="!isStandalone && isCisco">
        <div class="title-h4 title-bar">무선 AP 원격 제어</div>
        <el-row :gutter="4" class="mr-b25">
          <!-- <el-col :span="8"><el-button style="width:100%;" @click="onClickExecuteAgentStart" size="small"><i class="fas fa-play-circle text-14 mr-r4"/>시작</el-button></el-col>
          <el-col :span="8"><el-button style="width:100%;" @click="onClickExecuteAgentStop" size="small"><i class="fas fa-pause-circle text-14 mr-r4" />중지</el-button></el-col> -->
          <el-col :span="24">
            <el-button style="width:100%;" @click="onClickExecuteRestart" size="small"><i class="far fa-sync-alt mr-r4" style="font-size: 12px" />재기동</el-button></el-col
          >
        </el-row>
      </div>
      <w-basic-sliding-button-group :obj-info="objInfo" />
    </div>
    <div v-else>
      <el-row :gutter="4" class="mr-b4">
        <el-col :span="12">
          <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
        </el-col>
        <el-col :span="12">
          <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import { objCompanyDefine } from '@/constants/company';
import MsgUtil from '@/utils/message';
import { NOTIFY_DURATION } from '@/utils/hambuger-popup';
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import wireelssDeviceApi from '@/api/config/wireless-device/wireless-device-info';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WCommonScriptPopupButton from './CommonScriptPopupButton';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';
import WNetdeviceUserDefineOidRscPopupButton from './NetdeviceUserDefineOidRscPopupButton';
import WDeviceModelingButton from './button/netdevice/DeviceModelingButton';
import WConfigBackupButton from './button/netdevice/ConfigBackupButton';
import WDailyCheckButton from './button/netdevice/DailyCheckButton';

export default {
  name: 'WApSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WCommonSettingChartTypePopupButton,
    WCommonScriptPopupButton,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
    WNetdeviceUserDefineOidRscPopupButton,
    WDeviceModelingButton,
    WConfigBackupButton,
    WDailyCheckButton,
  },
  mixins: [HambugerPopupMixin],
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    isStandalone() {
      if (!isNil(this.objInfo.obj.parentObjId)) {
        return false;
      }
      return true;
    },
    /**
     * 무선 AP 제조사 Cisco 여부
     * @author Ju
     * @return {Boolean}
     */
    isCisco() {
      return objCompanyDefine.CISCO === this.objInfo.obj.objCompanyId;
    },
  },
  methods: {
    /**
     * 무선 AP를 재기동한다.
     * @author Ju
     */
    onClickExecuteRestart() {
      const target = '무선 AP';
      const action = '재기동';
      this.$confirm(...MsgUtil.getCustomConfirmData(`${target}를 ${action}하시겠습니까?`))
        .then(() => {
          wireelssDeviceApi
            .restartAp(this.objInfo.obj.objId)
            .then((result) => {
              if (result.data.success === true) {
                const data = {
                  title: '무선 AP 원격 제어',
                  message: '무선 AP를 재기동하였습니다.',
                  duration: NOTIFY_DURATION,
                };
                this.$notify(data);
              } else {
                this.$message(MsgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch((e) => {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ApSlidingButtonGroup.vue